import React from 'react'
import { Link } from 'react-router-dom'
import {ShieldCheck, FileText, LifeBuoy, Mail} from 'lucide-react'

export default function Footer() {
  return (
    <footer className="bg-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <ShieldCheck className="w-6 h-6 text-blue-400" />
              <span className="text-lg font-bold">PluginsForWHMCS.com</span>
            </div>
            <p className="text-slate-400 text-sm">
              Official, licensed WHMCS plugins built by verified developers.
            </p>
          </div>

          {/* Products */}
          <div>
            <h3 className="font-semibold text-white mb-4">Products</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/plugins" className="text-slate-600 hover:text-blue-600 transition-colors">
                  All Plugins
                </Link>
              </li>
              <li>
                <Link to="/wordpress-integration" className="text-slate-600 hover:text-blue-600 transition-colors">
                  WordPress Integration
                </Link>
              </li>
              <li>
                <Link to="/elementor-whmcs" className="text-slate-600 hover:text-blue-600 transition-colors">
                  Elementor WHMCS
                </Link>
              </li>
              <li>
                <Link to="/cpanel-integration" className="text-slate-600 hover:text-blue-600 transition-colors">
                  cPanel Integration
                </Link>
              </li>
              <li>
                <Link to="/discord-notifications" className="text-slate-600 hover:text-blue-600 transition-colors">
                  Discord Notifications
                </Link>
              </li>
              <li>
                <Link to="/stripe-payment" className="text-slate-600 hover:text-blue-600 transition-colors">
                  Stripe Payment Gateway
                </Link>
              </li>
              <li>
                <Link to="/crypto-payment" className="text-slate-600 hover:text-blue-600 transition-colors">
                  Crypto Payment Module
                </Link>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="font-semibold text-white mb-4">Resources</h3>
            <ul className="space-y-2">
              <li>
                <a href="#" className="text-slate-600 hover:text-blue-600 transition-colors">
                  Documentation
                </a>
              </li>
              <li>
                <a href="#" className="text-slate-600 hover:text-blue-600 transition-colors">
                  Support
                </a>
              </li>
              <li>
                <Link to="/blog" className="text-slate-600 hover:text-blue-600 transition-colors">
                  Blog & Guides
                </Link>
              </li>
              <li>
                <a href="#" className="text-slate-600 hover:text-blue-600 transition-colors">
                  Installation Guides
                </a>
              </li>
            </ul>
          </div>

          {/* Legal & Support */}
          <div>
            <h3 className="font-semibold text-white mb-4">Legal & Support</h3>
            <ul className="space-y-2">
              <li>
                <a href="#" className="text-slate-600 hover:text-blue-600 transition-colors">
                  Terms of Service
                </a>
              </li>
              <li>
                <a href="#" className="text-slate-600 hover:text-blue-600 transition-colors">
                  Refund Policy
                </a>
              </li>
              <li>
                <a href="#" className="text-slate-600 hover:text-blue-600 transition-colors">
                  Privacy Policy
                </a>
              </li>
              <li>
                <a href="#" className="text-slate-600 hover:text-blue-600 transition-colors">
                  Contact Support
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-8 pt-8 text-center text-slate-400 text-sm">
          <p>&copy; 2024 PluginsForWHMCS.com. All rights reserved. Official licensed plugins only.</p>
        </div>
      </div>
    </footer>
  )
}
